<section class="technologies">
  <div class="container">
    <div class="row">
      <div class="col-lg-12" data-aos="fade-up">
        <h2>TECNOLOGÍA Y SERVICIOS PARA TU OPERACIÓN</h2>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="containerTechnologies">
        <div
          class="spares"
          data-aos="fade-right"
          (click)="
            goToLink(
              'https://parts.cat.com/es/tracsa?utm_source=website&utm_medium=referral&utm_campaign=PCC&utm_id=PCC',
              true
            )
          "
        >
          <div class="contentImage">
            <img
              ngSrc="/home/technologies/spares.webp"
              alt="Venta en línea de refacciones Caterpillar"
              fill
            />
          </div>
          <div class="containerText">
            <a
              href="https://parts.cat.com/es/tracsa?utm_source=website&utm_medium=referral&utm_campaign=PCC&utm_id=PCC"
              target="_blank"
              rel="noopener noreferrer"
              ><h3>ENCUENTRA LAS REFACCIONES PARA TU EQUIPO</h3></a
            >
            <p>
              Con las refacciones originales Cat aseguras el máximo rendimiento de tus equipos y la
              mayor productividad en tus operaciones.
            </p>
          </div>
          <button class="btnTracsa btnResizeYellowBlack">
            <div>IR A PARTS.COM</div>
          </button>
        </div>
        <div class="financing" data-aos="fade-down" (click)="goToLink('/financiamiento')">
          <div class="contentImage">
            <img
              ngSrc="/home/technologies/financing.webp"
              alt="Cliente celebrando la adquisición de maquinaria Caterpillar mediante financiamiento"
              fill
            />
          </div>
          <div class="containerText">
            <a routerLink="/financiamiento"><h3>FINANCIAMIENTO</h3></a>
            <p>
              Adquiere tu equipo con financiamiento hasta por 60 meses. Además, conoce todas las
              opciones que tenemos para ti para la compra o renta de equipos, refacciones y
              servicios.
            </p>
          </div>
          <button class="btnTracsa btnResizeYellowBlack">
            <div>SABER MÁS</div>
          </button>
        </div>
        <div class="technologyCAT" data-aos="fade-down" (click)="goToLink('/soluciones-digitales')">
          <div class="contentImage">
            <img
              ngSrc="/home/technologies/technologies.webp"
              alt="Soluciones digitales Caterpillar para la gestión, el mantenimiento y el monitoreo de maquinaria."
              fill
            />
          </div>
          <div class="containerText">
            <a href="/soluciones-digitales"><h3>SOLUCIONES DIGITALES</h3></a>
            <p>
              Optimiza el potencial de tus equipos al máximo. Con VisionLink, SIS2GO y Cat App
              podrás monitorear, dar mantenimiento y optimizar el rendimiento de tus equipos, todo
              desde tu dispositivo.
            </p>
          </div>
          <button class="btnTracsa btnResizeYellowBlack">
            <div>SABER MÁS</div>
          </button>
        </div>
        <div class="promotions" data-aos="fade-up" (click)="goToLink('/promociones')">
          <div class="contentImage">
            <img
              ngSrc="/home/technologies/promotions.webp"
              alt="Operador con casco CAT junto a maquinaria pesada en promoción."
              fill
            />
          </div>
          <div class="containerText">
            <a routerLink="/promociones"><h3>PROMOCIONES</h3></a>
            <p>
              Ofertas especiales en maquinaria, refacciones y servicio. Descubre nuestras
              promociones mensuales con precios exclusivos y recibe asesoría personalizada para
              encontrar justo lo que necesitas.
            </p>
          </div>
          <button class="btnTracsa btnResizeYellowBlack">
            <div>SABER MÁS</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
